export const PARTNER_SEARCH_COLUMNS = [
  { name: 'vendorId', title: 'Partner Id' },
  { name: 'companyName', title: 'Company Name' },
  { name: 'city', title: 'City' },
];

export const PARTNER_SEARCH_COLUMN_EXTENSIONS = [
  { columnName: 'vendorId', width: 150 },
  { columnName: 'companyName', width: 300 },
  { columnName: 'city', width: 175 },
];

export const PARTNER_ID_KEY = 'vendorId';
export const PARTNER_NAME_KEY = 'companyName';

export const partnerSearchInfo = (partners) => ({
  searchingColumns: PARTNER_SEARCH_COLUMNS,
  searchingColumnExtensions: PARTNER_SEARCH_COLUMN_EXTENSIONS,
  searchingRows: Array.isArray(partners) ? partners : [],
  idKey: PARTNER_ID_KEY,
  nameKey: PARTNER_NAME_KEY,
});

export const findPartnerName = (partners, partnerId) => {
  if (partnerId === null || partnerId === undefined || partnerId === '' || partnerId === 0) return '';
  const partner = (Array.isArray(partners) ? partners : []).find((p) => p[PARTNER_ID_KEY] === partnerId);
  return partner ? partner[PARTNER_NAME_KEY] ?? '' : '';
};
